var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('go-input',{attrs:{"AUTOCOMPLETE":"off","readOnly":true,"suffix":_vm.suffixIcon,"width":this.width,"item":this.inputItem},on:{"suffixClick":_vm.suffixClick,"initElObj":_vm.initElObj},model:{value:(_vm.curDate),callback:function ($$v) {_vm.curDate=$$v},expression:"curDate"}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/go-calendar.vue